module.exports = __webpack_public_path__ + "static/media/Lib5.955fbe0c.jpg";